import { Roster as RosterType, RosterCoach, RosterPlayer } from "../../state/data/useTeamRoster";
import { PositionedRoster } from "./PositionedRoster";
import { VerticalRoster } from "./VerticalRoster";

export type RosterProps = {
    roster: RosterType;
    layout?: "vertical" | "positioned";
    onClickCoach?: (coach: RosterCoach) => void;
    onClickPlayer?: (player: RosterPlayer) => void;
};

export function Roster({ roster, onClickCoach=()=>{}, onClickPlayer=()=>{}, layout="vertical" }:RosterProps){

    switch(layout){
        default:
        case "vertical": return <VerticalRoster roster={roster} onClickCoach={onClickCoach} onClickPlayer={onClickPlayer} />
        case "positioned": return <PositionedRoster roster={roster} onClickCoach={onClickCoach} onClickPlayer={onClickPlayer} />
    }

}